
const CopySomething = {
  install (Vue) {
    Vue.directive('copy', {
      bind (el, {
        value
      }) {
        el.$value = value
        el.handler = () => {
          if (el.$value) {
            const textarea = document.createElement('textarea')
            // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
            textarea.readOnly = 'readonly'
            textarea.style.position = 'absolute'
            textarea.style.left = '-9999px'
            textarea.style.width = 0
            textarea.style.height = 0
            // 将要 copy 的值赋给 textarea 标签的 value 属性
            textarea.value = el.$value
            document.body.appendChild(textarea)
            // 选中值并复制 兼容IOS 没有 select() 方法
            if (textarea.createTextRange) {
              textarea.select() // 选中值并复制
            } else {
              textarea.setSelectionRange(0, el.$value.length)
              textarea.focus()
            }
            // 异步剪切板api
            if (navigator.clipboard && window.isSecureContext) {
              navigator.clipboard.writeText(el.$value).then(() => {
                // console.log('copy成功:', textarea.value)
                document.body.removeChild(textarea)
              }).catch((err) => {
                console.log('error', err)
              })
            } else {
              const flag = document.execCommand('Copy')
              if (flag) {
                // console.log('copy成功:', textarea.value)
                document.body.removeChild(textarea)
              }
            }
          }
        }
        el.addEventListener('click', el.handler)
      },
      componentUpdated (el, {
        value
      }) {
        el.$value = value
      },
      unbind (el) {
        el.removeEventListener('click', el.handler)
      }
    })
  }
}

export default CopySomething
